"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../../../preact-components/User/UserAvatar"));

var UserCell = function UserCell() {
  return function (_ref) {
    var id = _ref.id,
        username = _ref.username,
        email = _ref.email,
        avatar = _ref.avatar,
        url = _ref.url,
        isInvite = _ref.isInvite;
    var user = {
      id: id,
      name: isInvite ? email : username,
      avatar: avatar || '',
      url: url
    };
    return (0, _preact.h)("div", {
      className: "team-overview__table-user ".concat(isInvite ? 'qa-is-invite' : '')
    }, (0, _preact.h)(_UserAvatar.default, {
      user: user,
      openInNewTab: true,
      style: {
        width: '40px',
        height: '40px'
      }
    }), isInvite ? (0, _preact.h)("div", {
      className: "team-overview__table-user__email"
    }, email) : (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(user.url),
      target: "_blank",
      className: "team-overview__table-user__link"
    }, (0, _preact.h)("div", {
      className: "team-overview__table-user__username"
    }, username), (0, _preact.h)("div", {
      className: "team-overview__table-user__email"
    }, email)));
  };
};

var _default = UserCell;
exports.default = _default;